import { combineReducers } from "redux";
import publicTemplatesReducer from "./publicTemplatesReducer";

const guildlibrarianReducer = combineReducers({
    publicTemplates: publicTemplatesReducer,
});

export default guildlibrarianReducer;
